export default __webpack_public_path__ + "static/media/webQuotationHome.e92d4d51.png";